module.exports = __webpack_public_path__ + "static/media/google.309a1fa8.png";